import { SET_STEP } from '../constants/actions';
import { QUOTE_QUANTITY } from '../constants/config';

export function setStep(state = 0, action) {
  switch (action.type) {
    case SET_STEP:
      return action.payload;
    default:
      return state;
  }
}

export function setSteps() {
  const steps = [...Array(QUOTE_QUANTITY).keys()].map(step => `0${step + 1}`);
  return [
    ...steps,
    'end'
  ];
}



/** WEBPACK FOOTER **
 ** ./src/js/reducers/reducer-steps.js
 **/